import request from "@utils/request";

export function getDataHighTradeCount(query) {
    return request({
        url: 'alert/data/high-trades',
        method: 'get',
        params: query
    })
}
